module.exports = __webpack_public_path__ + "media/images/requisitions/yd_head-62ae066e48351125ca07cdfdafb5423e.png";